import clsx from "classnames";
import classes from "./styles.module.scss";
import DiscoverScroll from "@/components/DiscoverScroll";
import Body from "@/ui/Body";
import Title from "@/ui/Title";
import QuoteLeft from "@/assets/QuoteLeft.svg";
import Image from "@/ui/Image";

export default function CEOStatement({ className, statement, content }) {

  return (
    <div className={clsx(className, classes.ceo)}>
      <div className={classes.left_section}>
        <Title title="CEO STATEMENT" className="quaternary" tag="h2" />
        <div className={classes.icon}><QuoteLeft /></div>
        <Title title={statement} tag="div" className={`h3 ${classes.statement}`} />
        <Body className={classes.body} body={content} />
        <div className={`h6 ${classes.ceo_name}`}>Adam Blaney, CEO</div>
      </div>
      <div className={classes.right_section}>
        <Image img="/CEO_statement_small.png" size="356x400" alt="Adam Blaney, CEO" />
      </div>
    </div>
  );
}

CEOStatement.defaultProps = {
  className: "",
};
